import FigureImageExpansionTemplateNode from './FigureImageExpansionTemplateNode';
import { ExpansionTemplateInfo } from './Contexts';
import { useContext } from 'react';

import randomRGB from './randomRGB';

export default function FigureImageExpansionTemplateLayout({
  nodeId, 
  nodes,
  templateId,
  setContextMenuConfig,
  onEvent,
}){



  let node = nodes[nodeId];

  

  let { d, c, value } = node || {};

  let parent = nodes[ node.p ];



  let parentStyle = node.style || {};


  let nodeDims = { w:1, h: 1};


  let isRoot = nodeId === "root";


  let nodeWidth = (nodeDims.w) * 100 + '%';
  let nodeHeight = (nodeDims.h) * 100 + '%';
  let aspectRatio;

  if( isRoot ){
    nodeWidth = '100%';
    nodeHeight = undefined;
    aspectRatio = `${nodeDims.w} / ${nodeDims.h}`
  }

  return (


    <div class={(d === "h" ? "sg-row" : "sg-col")  } style={{

      position:'relative',
      //border:`3px solid red`// ${randomRGB()}`
    }}>


      {value && <div style={{
        //border:'3px solid red'
      }}>


        <FigureImageExpansionTemplateNode {...{
          node, nodeId, nodes,
          setContextMenuConfig,
          templateId,
          onEvent,
        }}/>
      </div>}

      {!value && (
        (c||[]).map(nodeId => {
          return(
            <FigureImageExpansionTemplateLayout key={nodeId} {...{nodeId, nodes, 
              onEvent,
              templateId, setContextMenuConfig}}/>
          )
        })
      )}
    </div>
  )



}

function NodeIdWrapper({nodeId,children}){
  return (
    <div>
      <div>{nodeId}</div>
      {children}
    </div>
  )
}
